import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Login"
import Register from "./Register"
import Home from './Home';
import School from './school';
import GradeClass from './grade_class';
import UserInfo from "./user_info"
import Record from './record';
import Complete_register from './complete_register';
import Gender_picker from './gender_picker';
import { UploadFace } from './user_info/upload_face';
import { UpdateInfo } from './user_info/update_info';
import { LoginView } from './Login/login_view';
import { SignUpView } from './Register/signup';
import { ModifyPwd } from './modify_pwd/modify_pwd';
import { SettingView } from './setting/setting';
import { ExemptView } from './exempt/exempt';
import { useEffect } from 'react';
import { ClassImportTutorials } from './tutorials/class_import/class_import';
import { DownloadView } from './tutorials/download/download';
import { StuDownload } from './student_download/stu_download';
function App() {

  useEffect(()=>{
    let query = window.location.search.substring(1)
    let params = {}
    query.split("&").forEach(r=>{
      let kv = r.split("=")
      params[kv[0]] = kv[1]
    })
    console.log(params)
  },[])

  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/login" element={<Login />} /> */}
        {/* <Route path="/register" element={<Register />} /> */}
        <Route path="/" element={<StuDownload />} />
        {/* <Route path="/set_school" element={<School />} />
        <Route path="/set_grade_class/:id" element={<GradeClass />} />
        <Route path="/set_user_info" element={<UserInfo />} />
        <Route path="/records" element={<Record />} />
        <Route path="/complete_register" element={<Complete_register />} />
        <Route path="/upload_face" element={<UploadFace />} />
        <Route path="/update_info" element={<UpdateInfo />} />
        <Route path="/login_view" element={<LoginView />} />
        <Route path="/signup_view" element={<SignUpView />} />
        <Route path="/modify_pwd" element={<ModifyPwd />} />
        <Route path="/setting" element={<SettingView />} />
        <Route path="/exempt" element={<ExemptView />} /> */}
        <Route path="/tutorials/class_import" element={<ClassImportTutorials />} />
        <Route path="/download" element={<StuDownload />} />
        {/* <Route path="/view" element={<Gender_picker />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
